<template>
	<v-container class="mt-12 pt-8" style="background:#fafafa;">
		<v-row style="background:#fafafa;">
			<v-col cols="12" class="pa-0">
				<v-row class="py-1 px-5">
					<v-col cols="12" md="12" LeadsPannel>
						<v-row>
							<v-col cols="12" LEADSPANEL>
								<v-card :loading="loading">
									<v-card-text class="py-0">
										<v-row class="align-center">
											<v-col cols="12">
												<v-row class="align-center">
													<v-col cols="2" class="text-center" TITLE>
														<v-icon size="40" color="secondary">description</v-icon>
													</v-col>
													<v-col cols="10" TITLE>
														<div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
														 {{i18n['new_purchaseOrder']}}
														</div>
														<div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">{{ i18n['start_a_new_purchaseOrder'] }}</div>
													</v-col>
												</v-row>
											</v-col>
											<v-col cols="12" class=" py-0">
												<Form @onSubmit="onSubmit" :resource.sync="resource" :countries="countries" />
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Form from './Form.vue';

export default {
	components: {
		Form
	},
	data() {
		return {
			loading: false,
			resource: {
				items:[
					{
						title_en: "",
						title_ar: "",
						price: "",
						description: "",
						image: "",
						source_url: "",
						quantity:1,
						origin: "",
						destination: "",
						note: "",
					},
				]
			}
		};
	},
	methods: {
		getUpload(image) {
			this.resource.image = image.value
		},
		async onSubmit() {
			this.loading = true
			console.log(this.resource)
			await this.$store.dispatch('postResource', { resource: '/purchase-orders', value: this.resource })
			this.loading = false
			this.$router.push('/purchase-orders')
		}
	},
	computed: {
		language() {
			return this.$store.state.language;
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language];
		},
		arabic() {
			if (this.$store.state.language == "ar")
				return true;
		},
		countries() {
      const keys = Object.keys(this.$store.state.countries_[this.language])
      const values = Object.values(this.$store.state.countries_[this.language])
      const countries = values.map((val, i)=>{
        return {
          text: val, value:keys[i]
        }
      })
      return countries || []
    }
	},
}
</script>